import { render } from "./tables.vue?vue&type=template&id=4c870e59&scoped=true"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"

import "./tables.vue?vue&type=style&index=0&id=4c870e59&lang=css"
import "./tables.vue?vue&type=style&index=1&id=4c870e59&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c870e59"]])

export default __exports__